// Фильтр number из AngularJS 1.2 с русским форматом чисел («1 234,5»). Свои фильтры сайт
// регистрирует через angular.module(...).filter.
import { reportWarning } from './report';

const PATTERN = { gSize: 3, lgSize: 3, maxFrac: 3, minFrac: 0 };
// Неразрывный пробел между разрядами, как в angular-locale_ru.js.
const GROUP_SEP = '\u00a0';
const DECIMAL_SEP = ',';

// Перенос formatNumber из AngularJS 1.2.29 без изменений логики.
export function formatNumber(number, fractionSize) {
    if (number == null || !isFinite(number) || (number !== null && typeof number === 'object')) {
        return '';
    }
    let isNegative = number < 0;
    number = Math.abs(number);
    let numStr = number + '';
    let formattedText = '';
    let hasExponent = false;
    if (numStr.indexOf('e') !== -1) {
        const match = numStr.match(/([\d.]+)e(-?)(\d+)/);
        if (match && match[2] === '-' && match[3] > fractionSize + 1) {
            numStr = '0';
            number = 0;
        } else {
            formattedText = numStr;
            hasExponent = true;
        }
    }
    if (hasExponent) {
        if (fractionSize > 0 && number > -1 && number < 1) {
            formattedText = number.toFixed(fractionSize);
        }
    } else {
        const fractionLen = (numStr.split('.')[1] || '').length;
        if (typeof fractionSize === 'undefined') {
            fractionSize = Math.min(Math.max(PATTERN.minFrac, fractionLen), PATTERN.maxFrac);
        }
        number = +(Math.round(+(number.toString() + 'e' + fractionSize)).toString() + 'e' + -fractionSize);
        if (number === 0) {
            isNegative = false;
        }
        const split = ('' + number).split('.');
        const whole = split[0];
        let fraction = split[1] || '';
        let pos = 0;
        const lgroup = PATTERN.lgSize;
        const group = PATTERN.gSize;
        if (whole.length >= lgroup + group) {
            pos = whole.length - lgroup;
            for (let i = 0; i < pos; i++) {
                if ((pos - i) % group === 0 && i !== 0) {
                    formattedText += GROUP_SEP;
                }
                formattedText += whole.charAt(i);
            }
        }
        for (let i = pos; i < whole.length; i++) {
            if ((whole.length - i) % lgroup === 0 && i !== 0) {
                formattedText += GROUP_SEP;
            }
            formattedText += whole.charAt(i);
        }
        while (fraction.length < fractionSize) {
            fraction += '0';
        }
        if (fractionSize && fractionSize !== '0') {
            formattedText += DECIMAL_SEP + fraction.substr(0, fractionSize);
        }
    }
    return (isNegative ? '-' : '') + formattedText;
}

export function toJson(value) {
    if (typeof value === 'undefined') {
        return undefined;
    }
    return JSON.stringify(value, (key, val) => (typeof key === 'string' && key.charAt(0) === '$' && key.charAt(1) === '$' ? undefined : val));
}

export function equals(a, b) {
    if (a === b) {
        return true;
    }
    if (a === null || b === null || typeof a !== 'object' || typeof b !== 'object') {
        // eslint-disable-next-line no-self-compare
        return a !== a && b !== b;
    }
    if (Array.isArray(a) !== Array.isArray(b)) {
        return false;
    }
    const keys = Object.keys(a).filter(k => k.charAt(0) !== '$' && typeof a[k] !== 'function');
    const keysB = Object.keys(b).filter(k => k.charAt(0) !== '$' && typeof b[k] !== 'function');
    if (keys.length !== keysB.length) {
        return false;
    }
    return keys.every(k => equals(a[k], b[k]));
}

// Реестр фильтров. parse получает filters.get, приложение добавляет свои фильтры через register.
export function createFilters() {
    const registry = new Map([['number', formatNumber]]);
    const warned = new Set();
    return {
        register(name, fn) {
            registry.set(name, fn);
        },
        get(name) {
            const fn = registry.get(name);
            if (!fn && !warned.has(name)) {
                warned.add(name);
                reportWarning(`Фильтр «${name}» не найден, значение выводится без него.`);
            }
            return fn;
        },
    };
}
